var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PubSubService } from './angular2-pubsub.service';
import { NgModule } from '@angular/core';
var PubSubModule = PubSubModule_1 = (function () {
    function PubSubModule() {
    }
    PubSubModule.forRoot = function () {
        return {
            ngModule: PubSubModule_1,
            providers: [
                PubSubService
            ]
        };
    };
    return PubSubModule;
}());
PubSubModule = PubSubModule_1 = __decorate([
    NgModule({
        providers: [
            PubSubService
        ]
    })
], PubSubModule);
export { PubSubModule };
var PubSubModule_1;
//# sourceMappingURL=angular2-pubsub.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-pubsub/esm/src/angular2-pubsub.module.js
// module id = 524
// module chunks = 4